<template>
  <div class="data-container">
    <div class="title fix-box-align-center" v-if='title'>
      <img src="/img/bigdata/title-icon.png" alt="" style='margin-right: 12px;'>
      {{title}}
    </div>
    <div class="horn horn-lt" v-if='!noLeft'/>
    <div class="horn horn-rt"/>
    <div class="horn horn-lb"/>
    <div class="horn horn-rb"/>
    <noData   v-if='!loading&&nodata' style='position: absolute;left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);'/>
    <template v-else>
      <div class='slot'>
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script>
  import noData from "./noData";
  export default {
    name: "container",
    props:{
      title:{
        type:String,
      },
      noLeft:{
        type:Boolean,
        default:false,
      },
      nodata:{
        type:Boolean,
      },
      loading:{
        type:Boolean,
      },
    },
    components: {
      noData,
    },
    data() {
      return {}
    },
    methods: {},
    created() {

    },
  }
</script>

<style scoped lang="scss">
  .data-container {
    padding: 15px;
    position: relative;
    border: 1px solid #1D3E8F;
    border-radius:1px;
    box-sizing: border-box;
    .title{
      color: #B8D7FF;
      font-size: 16px;
      font-family:Helvetica;
    }
    .horn{
      position: absolute;
      width: 13px;
      height: 12px;
    }
    .horn-lt{
      border-top: 2px solid #4291F8;
      border-left: 2px solid #4291F8;
      top: -2px;
      left: -2px;
      border-radius: 4px 0 0 0;
    }
    .horn-rt{
      border-top: 2px solid #4291F8;
      border-right: 2px solid #4291F8;
      top: -2px;
      right: -2px;
      border-radius: 0 4px 0 0;
    }
    .horn-lb{
      border-bottom: 2px solid #4291F8;
      border-left: 2px solid #4291F8;
      bottom: -2px;
      left: -2px;
      border-radius: 0 0 0 4px;
    }
    .horn-rb{
      border-bottom: 2px solid #4291F8;
      border-right: 2px solid #4291F8;
      bottom: -2px;
      right: -2px;
      border-radius: 0 0 4px 0;
    }
  }
</style>
